'use strict';
  
angular.module('buyersService')
.factory('MailService', ['appInfo', '$log', '$rootScope', '$http', '$q', 'CacheFactory', 
    function (appInfo, $log, $rootScope, $http, $q, CacheFactory) {
        var service = {}
            , code    = $rootScope.currentUser.authdata
            , expires =  moment().add(15, 'm').unix();

        if (!CacheFactory.get('mailCache')) {
            sellerCache = CacheFactory('mailCache', { maxAge: 15 * 60 * 1000, deleteOnExpire: 'aggressive' });
        }

        // Send an email back to WOL
        service.sendMail = function(dataString) {
            var dfd = $q.defer();

            $http({
                    url: appInfo.endpoint+'otherusers/sendEmail.json', 
                    method: "POST",
                    params: {api_key: appInfo.key },
                    data: { data: dataString }
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject(data); 
                });

            return dfd.promise;

        };

        // Mark message 'as read'
        service.markAsRead = function(usercode, ref) {
            // var dfd = $q.defer();
             
            console.log('marked as read')

            // $http({
            //         url: appInfo.endpoint+'otherusers/markmessageread.json', 
            //         method: "GET",
            //         params: {usercode: usercode, ref: ref, api_key: appInfo.key},
            //         cache: CacheFactory.get('mailCache')
            //     }).success(function(data) {
            //         dfd.resolve(data);
            //     }).error(function(data, status, headers, config) {
            //         dfd.reject("Error: status " + status); 
            //     });

            // return dfd.promise;

        };
        
        return service;

}]);